import React, { PureComponent } from 'react'
import DocumentTitle from 'react-document-title'
import {
  string, node, func, shape, oneOfType,
} from 'prop-types'
import humps from 'humps'
import classNames from 'classnames'
import includes from 'lodash/fp/includes'

import { withI18n } from '@active/react-utils/i18n'

import { getUrlParams } from '../../shared/utils/commonUtils'
import Footer from '../common/Footer'
import Header, { PageHeader } from '../common/Header'
import BrowserSupport from '../common/BrowserSupport'
import { CommonProvider } from '../../widgets/widgetCommonContext'
import './passportDefaultPage.scss'

class PassportDefaultPage extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    widget: oneOfType([func, shape({}), node]).isRequired,
    titleKey: string.isRequired,
    pageMode: string,
  }

  static defaultProps = {
    pageMode: 'page',
  }

  render() {
    const {
      widget: Widget, titleKey, i18n, pageMode, ...rest
    } = this.props

    const urlParams = getUrlParams()
    const params = Object.keys(urlParams)
      .reduce((acc, key) => Object.assign(acc, { [humps.camelize(key)]: urlParams[key] }), {})

    const pageClass = classNames({
      [`passport-ui-${pageMode}`]: true,
    })
    const isFullPage = pageMode === 'fullpage'
    const footerClass = classNames({
      'fullpage-footer': isFullPage,
    })

    // TODO: move to PassportRoute
    const userAg = window.navigator.userAgent
    if (includes('MSIE')(userAg) || includes('Trident')(userAg)) {
      return (
        <>
          <DocumentTitle title={i18n(titleKey)} />
          <div className="passport-ui-message__container">
            <BrowserSupport />
            <Footer />
          </div>
        </>
      )
    }
    const passportAPIServerHost = window.passportAPIServerHost || window.location.origin
    return (
      <>
        <DocumentTitle title={i18n(titleKey)} />
        {isFullPage && <PageHeader />}
        <div className={pageClass}>
          <CommonProvider
            value={{ passportAPIServerHost: passportAPIServerHost }}
          >
            <Widget
              {...params}
              {...rest}
              passportAPIServerHost={passportAPIServerHost}
              keycloakAPIServerHost={window.keycloakAPIServerHost || `${passportAPIServerHost}/v5`}
              Header={Header}
            />
          </CommonProvider>
        </div>
        {pageMode !== 'content' && (
          <div className={footerClass}>
            <Footer />
          </div>
        )}
      </>
    )
  }
}

export default withI18n(PassportDefaultPage)
